<template>
  <div class="badge" :class="`${type} ${absolute ? 'absolute' : ''}`">
    {{ name }}
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    type: { type: String, default: 'neutral' },
    absolute: { type: Boolean, default: true },
  },
};
</script>
<style scoped>
.badge {
  border-radius: 5px;
  padding: 5px 10px;
  line-height: 12px;
  font-size: 12px;
  text-align: center;
  font-weight: 900;
  text-transform: uppercase;
}
.badge.absolute {
  position: absolute;
  right: 20px;
}
.badge.pro {
  background: linear-gradient(296deg, var(--default) 0%, #000033 100%);
  color: #fff;
}
.badge.exclamation {
  background: #ffcc9973;
  color: #ffcc99;
}
.badge.neutral {
  background: var(--box-up);
  color: var(--label-primary);
}
.badge.success {
  background: #354a49;
  color: #0dc59d9c;
}
.badge.danger {
  background: #5e4148;
  color: #db5266db;
}
.badge.gold {
  background: #ffcc991a;
  color: #ffcc99e0;
  font-weight: 400;
  text-transform: initial;
}
.badge.pink {
  background: #ff338226;
  color: #ff478f;
}

@media screen and (max-width: 991px) {
  .badge {
    line-height: 12px;
    font-size: 10px;
  }
}
</style>
